import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import ReactDOM from 'react-dom/client';
// import { Provider } from 'react-redux';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <Provider > */}
      <BrowserRouter>
        <HelmetProvider>
          <App />
        </HelmetProvider>

      </BrowserRouter>
    {/* </Provider> */}
  </React.StrictMode>,
);

